'use client';

import Button from 'molecules/Button';
import Image from 'molecules/Image';
import RichText from 'molecules/RichText';

import styles from 'components/Switchbacks/BasicSwitchback/text-image.module.scss';

import { isNonEmptyArray } from 'utils/functions';

import type { BasicSwitchbackProps } from 'components/Switchbacks/BasicSwitchback/config';
import type { ElementType, FC } from 'react';

type imagePositionType = 'top' | 'center' | 'bottom';

const updateImagePosition = (position: imagePositionType = 'center') => {
  const imageByImagePosition: Record<imagePositionType, string> = {
    top: styles.imageTop,
    center: styles.imagecCenter,
    bottom: styles.imageBottom,
  };

  return position ? imageByImagePosition[position] : undefined;
};

const BasicSwitchback: FC<BasicSwitchbackProps> = ({
  basicPoints,
  mediaPosition,
  imagePosition,
  image,
  size = 'mediumSquare',
}) => {
  const orderClass = mediaPosition === 'left' ? styles.left : styles.right;
  const mediaClassname = `${styles['image-container']} ${styles[size]}`;

  return (
    <section>
      <div className={`${styles.container} ${orderClass}`}>
        <div className={styles.textContainer}>
          {isNonEmptyArray(basicPoints) &&
            basicPoints?.map(({ eyebrow = '', body = '', cta = {}, footnote = '', eyebrowHtmlTag }, index) => {
              const EyebrowTag: ElementType = (eyebrowHtmlTag as ElementType) || 'h3';

              return (
                <div key={index}>
                  {eyebrow && <EyebrowTag className={styles.eyebrow}>{eyebrow}</EyebrowTag>}
                  {body && (
                    <RichText
                      className={styles.richText}
                      content={body
                        .replace(/\\b/g, '<div style="font-weight: 700; margin-bottom: 2rem">')
                        .replace(/\\cb/g, '</div>')}
                    />
                  )}
                  {cta?.label && cta?.link && (
                    <Button className={styles.arrowLink} direction="right" url={cta.link} iconId="arrow-right">
                      {cta.label}
                    </Button>
                  )}
                  {footnote && <span className={styles.footnote}>{footnote}</span>}
                </div>
              );
            })}
        </div>
        <div className={`${styles.image} ${updateImagePosition(imagePosition)}`}>
          <div className={mediaClassname}>
            <Image width={image?.width || 0} height={image?.height || 0} url={image?.url} alt={image?.alt || ''} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BasicSwitchback;
